import { render, staticRenderFns } from "./BoxLayoutInput.vue?vue&type=template&id=f0d47180&scoped=true&"
import script from "./BoxLayoutInput.vue?vue&type=script&lang=js&"
export * from "./BoxLayoutInput.vue?vue&type=script&lang=js&"
import style0 from "./BoxLayoutInput.vue?vue&type=style&index=0&id=f0d47180&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0d47180",
  null
  
)

export default component.exports